import {
  formatDateTime,
  formatDuration,
  timeStringToDate,
} from "../../common/helpers/time";

function formatEvents(event) {
  event.location = angular.fromJson(event.location);
  event.time = formatDateTime(timeStringToDate(event.time), "h:mm A");
  event.duration = formatDuration(event.duration);
  return event;
}

function AdminEventsController($scope, $state, UsersModel, EventsModel) {
  const vm = this;
  vm.maxSize = 5;
  vm.currentPage = 1;

  vm.pageChanged = function () {
    EventsModel.get({ page: vm.currentPage }).then(function (response) {
      vm.events = response.events.data.filter(formatEvents);
    });
  };

  EventsModel.get().then(function (response) {
    vm.events = response.events.data.filter(formatEvents);
    vm.totalItems = response.events.total;
  });
}

AdminEventsController.$inject = [
  "$scope",
  "$state",
  "UsersModel",
  "EventsModel",
];
export default AdminEventsController;

